import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

export const SkeletonAccordionItem = ({ defaultOpen }: { defaultOpen?: boolean }) => (
  <Skeleton
    className={cn(`w-full animate-pulse rounded-lg`, {
      'h-48': defaultOpen
    })}
  />
)

export const SkeletonAccordion = ({ defaultOpen }: { defaultOpen?: boolean }) => (
  <div className='flex flex-col gap-4'>
    <SkeletonAccordionItem defaultOpen={defaultOpen} />
    <SkeletonAccordionItem defaultOpen={defaultOpen} />
    <SkeletonAccordionItem defaultOpen={defaultOpen} />
  </div>
)
